export const onGetCurrencyValue = (number, precision) => {
    let result = ''
    if(!number) return '$0'
    let temp = parseFloat(number).toFixed(precision??2)
    result = temp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    result = `$${result}`
    return result
}